
<template>
  <div>
    <p class="lead mb-4">
      Turn this on if you sell on platforms other than eBay (Poshmark, Depop, local sales)
      and want to manually add orders or inventory so they’re included in your eShopCommand insights.
    </p>

    <div>
      <toggle-component :large="true" label="Crosslisting Mode" :toggled="enabled" @update:toggled="toggleCrosslisting" />
    </div>

    <div class="small text-info">
      <p v-if="!enabled">
        Simplified, eBay-only with automatic imports
      </p>
      <p v-else>
        Track inventory across platforms.
      </p>
    </div>

  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore} from "vuex";
const store = useStore();
const enabled = computed(() => store.state.eshop.eshop?.config?.CROSSLISTING)
import ToggleComponent from "@/app/components/Utils/ToggleComponent.vue";
function toggleCrosslisting(v) {
  store.dispatch("eshop/saveStoreConfig", {key: 'CROSSLISTING', val: v ? 1 : 0});
}
</script>